import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Edit3Icon, Share2Icon } from "lucide-react";
import style from "../../order-info/OrderInfoAviation.module.scss";
import expeditorStyle from "../../../orders-new/order-info-expeditor/OrderInfoExpeditor.module.scss";
import MoreIcon from "../../../shared/icons/MoreIcon";
import CopyIconNew from "../../../shared/icons/CopyIconNew";
import { User } from "../../../../services";
import { getAviationExpeditorMenuActions } from "./aviationExpeditorMenuActions";

const OrderInfoAviationExpeditorMoreMenu = ({ item, onChangeAmount }) => {
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const [isShareOpen, setIsShareOpen] = useState(false);
  const actions = getAviationExpeditorMenuActions(item?.status);

  useEffect(() => {
    setIsOpen(false);
    setShareLink("");
    setIsShareOpen(false);
  }, [item?.id]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
        setIsShareOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  if (!item || !actions.length) return null;

  const handleShare = async () => {
    if (shareLink) {
      setIsShareOpen((value) => !value);
      return;
    }

    try {
      const response = await User.guestLogin(item.id);
      const link = `${window.location.origin}/order/share/${response.data.accessToken}`;
      setShareLink(link);
      setIsShareOpen(true);
    } catch (error) {
      console.error(error);
      toast.error(t("orderInfoExpeditor.moreMenu.shareLinkError"));
    }
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareLink);
    toast.success(t("orderInfoExpeditor.moreMenu.linkCopied"));
    setIsShareOpen(false);
  };

  return (
    <div className={style.more_wrapper} ref={wrapperRef}>
      <button
        type="button"
        className={style.more_trigger}
        aria-label={t("tooltips.additionalMenu")}
        onClick={() => setIsOpen((value) => !value)}
      >
        <MoreIcon width={24} height={24} />
      </button>

      <div className={cn(style.more_dropdown, { [style.more_dropdown_open]: isOpen })}>
        {actions.includes("changeAmount") ? (
          <button
            type="button"
            className={style.more_dropdown_item}
            onClick={() => {
              setIsOpen(false);
              onChangeAmount?.();
            }}
          >
            <Edit3Icon size={18} color="#6D7885" />
            {t("orderInfoExpeditor.moreMenu.changeAmount")}
          </button>
        ) : null}

        {actions.includes("share") ? (
          <div>
            <button type="button" className={style.more_dropdown_item} onClick={handleShare}>
              <Share2Icon size={18} color="#6D7885" />
              {t("orderInfoExpeditor.moreMenu.shareOrder")}
            </button>
            {shareLink && isShareOpen ? (
              <div className={expeditorStyle.share_box}>
                <input type="text" value={shareLink} readOnly className={expeditorStyle.share_input} />
                <button type="button" className={expeditorStyle.share_copy_btn} onClick={handleCopy}>
                  <CopyIconNew />
                  <span>{t("orderInfoExpeditor.moreMenu.copy")}</span>
                </button>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default OrderInfoAviationExpeditorMoreMenu;
